import { ComponentPaintCollection } from "@omni/types/components/paintConfigurator/paintCollection.model";
import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { Mapped } from "@omni/utils/context/mapped.context";
import { isDefined } from "@omni/utils/helper.utils";
import { createContext, use } from "react";

type CollectionsContextValue = {
    collections: Array<ComponentPaintCollection>;
};

type CollectionsContextProviderProps = RequireChildrenFor<{
    collections: Array<ComponentPaintCollection>;
}>;

export const CollectionsContext = createContext<
    CollectionsContextValue | undefined
>(undefined);
CollectionsContext.displayName = "CollectionsContext";

export const CollectionsContextProvider = ({
    collections,
    children
}: CollectionsContextProviderProps) => {
    return (
        <CollectionsContext value={{ collections }}>
            <Mapped array={collections}>{children}</Mapped>
        </CollectionsContext>
    );
};

export const useCollectionsContext = () => {
    const context = use<CollectionsContextValue | undefined>(
        CollectionsContext
    );

    if (!isDefined(context)) {
        throw new Error(`${CollectionsContext.displayName} is undefined.`);
    }

    return context;
};
